export enum ExternalSupervisorInvitationStatus {
    notInitialized = '',
    saved = 'Saved',
    pending = 'Pending',
    approved = 'Approved',
    declined = 'Declined',
}
